import React from 'react';
import { fileUrl } from '@/lib/officialsApi';

export const INDICATORS = {
  available: { label: 'Available', dot: 'bg-emerald-500', text: 'text-emerald-700' },
  unavailable: { label: 'Unavailable', dot: 'bg-red-500', text: 'text-red-700' },
  unknown: { label: 'Unknown', dot: 'bg-white border-2 border-slate-300', text: 'text-slate-500' },
  conflict: { label: 'Scheduling Conflict', dot: 'bg-orange-500', text: 'text-orange-700' },
};

export const AvailabilityDot = ({ indicator, showLabel = false, testId }) => {
  const i = INDICATORS[indicator] || INDICATORS.unknown;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${i.text}`} data-testid={testId} title={i.label}>
      <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${i.dot}`} />
      {showLabel && i.label}
    </span>
  );
};

const STATUS = {
  pending: ['Pending Acceptance', 'bg-amber-50 text-amber-800 border-amber-200'],
  accepted: ['Accepted', 'bg-emerald-50 text-emerald-800 border-emerald-200'],
  declined: ['Declined', 'bg-red-50 text-red-700 border-red-200'],
  cancelled: ['Cancelled', 'bg-slate-100 text-slate-500 border-slate-200'],
};

export const AssignmentStatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || STATUS.pending;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-bold ${cls}`} data-testid={testId}>{label}</span>;
};

const STAFFING = {
  full: ['Fully staffed', 'bg-emerald-600 text-white'],
  partial: ['Partially staffed', 'bg-amber-400 text-[#1f1300]'],
  none: ['No officials', 'bg-red-600 text-white'],
  cancelled: ['Game cancelled', 'bg-slate-400 text-white'],
};

export const StaffingBadge = ({ staffing, filled, required, testId }) => {
  const [label, cls] = STAFFING[staffing] || STAFFING.none;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-bold uppercase tracking-wide ${cls}`} data-testid={testId}>
      {label}{staffing !== 'cancelled' && required ? ` · ${filled}/${required}` : ''}
    </span>
  );
};

export const OfficialAvatar = ({ name, photo, size = 'w-8 h-8' }) => {
  const initials = (name || '?').split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
  return photo ? (
    <img src={fileUrl(photo)} alt={name} className={`${size} rounded-full object-cover shrink-0 bg-slate-100`} />
  ) : (
    <span className={`${size} rounded-full bg-[#00247D]/10 text-[#00247D] text-[11px] font-bold flex items-center justify-center shrink-0`}>{initials}</span>
  );
};
